import { render } from "./ExternalLink.vue?vue&type=template&id=8c916efa"
const script = {}

import exportComponent from "/home/vinicius.valle/projetos/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__